import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Stack,
} from "@chakra-ui/react";
import { BaseStack } from "goi_common/src/design-system";
import { baseColors } from "goi_common/src/design-system";
import {
  call,
  ColorIcon,
  colors,
  customEvent,
  getCdnImageSrc,
  Image,
  RenewalFooter,
  responsive,
} from "goi_common";
import { useRouter } from "next/router";

// PC-only 오버라이드 (모바일은 className으로 처리)
const PC_BODY = {
  fontSize: { lg: "18px" },
  lineHeight: { lg: "29px" },
  letterSpacing: { lg: "-0.2px" },
} as const;

const PC_SECTION_TITLE = {
  fontSize: { lg: "24px" },
  lineHeight: { lg: "32px" },
  letterSpacing: { lg: "-0.3px" },
} as const;

const PC_CRITERION_TITLE = {
  fontSize: { lg: "18px" },
  lineHeight: { lg: "29px" },
} as const;

const PC_TABLE_LABEL = {
  fontSize: { lg: "18px" },
  lineHeight: { lg: "26px" },
  letterSpacing: { lg: "-0.2px" },
} as const;

const PC_TABLE_CELL = {
  fontSize: { lg: "17px" },
  lineHeight: { lg: "24px" },
  letterSpacing: { lg: "-0.2px" },
} as const;

const PC_FAQ = {
  fontSize: { lg: "18px" },
  lineHeight: { lg: "26px" },
  letterSpacing: { lg: "-0.2px" },
  fontWeight: { lg: "600" },
} as const;

const DIVIDER = <Box width="56px" height="1px" bg="#dddedf" flexShrink={0} />;
const TRUST_DIVIDER = (
  <Box height="1px" bg="#dddedf" width="100%" flexShrink={0} />
);

// ── 신뢰 섹션 아이콘 ──────────────────────────────────────────────

const IconKB = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
  >
    <rect width="36" height="36" fill="white" />
    <path
      d="M27.9016 14.6463L27.7248 14.5335C27.1212 13.9314 26.2797 13.6707 25.1563 13.7363C24.2203 13.7927 23.4779 14.1646 22.9109 14.5091C22.9109 14.5 22.9109 14.4924 22.9109 14.4832C22.9109 14.1906 22.9444 13.872 22.9764 13.564C23.0084 13.25 23.0435 12.9314 23.0435 12.6296C23.0435 12.3278 23.0084 12.029 22.9032 11.779C22.8758 11.715 22.8179 11.6769 22.7432 11.6769C22.4414 11.683 21.8499 11.8903 21.7066 12.0153L21.6289 12.186C21.6243 12.5214 21.5496 13.4558 21.4749 13.5701C21.478 13.5656 21.4353 13.6829 21.4353 13.6829C21.3072 15.0183 21.3057 16.192 21.4231 17.1996C21.4368 17.3003 21.6304 17.4512 21.7813 17.506C21.9459 17.567 22.4596 17.4283 22.7569 17.317C22.7523 17.317 22.8682 17.2987 22.8682 17.2987C22.9612 17.2881 23.0176 17.2103 23.013 17.1021C23.0115 17.1006 23.0206 16.8125 23.0206 16.8125C23.234 15.942 24.0999 14.904 25.1258 14.7485C25.705 14.657 26.1623 14.8049 26.5236 15.1997C26.5724 15.2698 26.6776 15.8963 26.2965 16.6158C26.0114 17.1478 25.4428 17.5975 24.6959 17.878C23.9886 18.1478 23.2096 18.256 22.2478 18.2225C22.2081 18.1966 21.3469 17.6143 21.3469 17.6143C20.5832 17.0792 19.6365 16.4116 18.7783 16.0869C18.6274 16.0289 18.3576 15.8033 18.1945 15.6692L18.1061 15.596C17.6106 15.1982 16.6671 14.5701 15.911 14.0656C15.911 14.0656 15.5695 13.8354 15.504 13.7927C15.504 13.7637 15.504 13.7073 15.504 13.7073C15.5268 13.6829 16.0024 13.3979 16.0024 13.3979C16.6686 13.0076 16.9765 12.8171 17.0421 12.718C17.0283 12.7333 17.1305 12.6662 17.1305 12.6662C17.1366 12.6631 18.7814 11.7317 18.7814 11.7317C20.3667 10.8613 22.1624 9.87202 23.106 8.89643C23.1075 8.89643 23.1517 8.74704 23.1517 8.74704L23.1715 8.61442C23.234 8.40558 23.2371 8.24553 23.1852 8.05955C23.1715 8.0062 23.1227 7.94523 23.0572 7.93303C22.3209 7.85986 21.3713 8.3004 20.5054 9.11289C20.3103 9.29581 20.1457 9.38575 19.9734 9.47874L19.8408 9.55343C18.8881 10.0946 16.7402 11.4284 15.6152 12.1479C15.6899 10.9391 15.9125 9.2196 16.1884 7.78517L16.1579 7.61444L16.0421 7.39798L15.9552 7.24249L15.9293 7.2364C15.7052 7.12207 15.5223 7.16932 15.3866 7.20286L15.1625 7.28518L14.8622 7.39493C14.8028 7.40713 14.7616 7.44371 14.7387 7.50011C14.2022 8.79735 13.754 10.9315 13.6473 12.6403C12.5741 11.9574 11.5833 11.468 11.0955 11.2302L11.0818 11.2226L11.0239 11.2104C10.8486 11.1876 10.6351 11.0595 10.4309 10.9345C10.408 10.9223 10.0224 10.6708 10.0224 10.6708L9.39889 10.2714L9.23426 10.2333C8.96597 10.279 8.45226 10.6251 8.29982 10.8613C8.28 10.8918 8.27086 10.9254 8.27086 10.9604C8.27086 11.0092 8.2861 11.0595 8.29982 11.1083L8.32726 11.2348L8.35622 11.311C8.655 11.6174 9.40956 12.1281 10.1489 12.5259L11.0056 12.9802L12.318 13.6967L12.5406 13.875L12.6946 13.9634C12.6946 13.9634 12.7129 13.9741 12.7235 13.9802C12.3744 14.2149 10.3364 15.5747 10.3364 15.5747L9.08182 16.407C8.96292 16.4878 8.4675 16.7088 8.35775 16.753C8.08641 16.8643 7.87909 17.0335 7.79525 17.2179L7.76172 17.2911L7.79525 17.3384L7.89129 17.4115L8.01934 17.4954L8.15805 17.5899L8.28915 17.6112C8.51018 17.6188 8.8364 17.4939 9.44767 17.2256C10.0086 16.9771 11.533 16.0579 12.1854 15.6646L12.4629 15.4985C12.5787 15.5076 12.7037 15.4116 12.818 15.3262C12.9491 15.221 13.2327 15.0472 13.4064 14.971C13.4125 14.9695 13.5101 14.9146 13.6046 14.8628C13.6046 14.8918 13.6031 14.9375 13.6031 14.9375C13.632 16.9314 13.7464 18.3795 13.9644 19.4969L13.9674 19.5167L13.9888 19.5609C14.0955 19.7179 14.2174 20.1905 14.3256 20.6066L14.5741 21.4389C14.5802 21.4481 14.6442 21.5167 14.6442 21.5167C14.786 21.6127 15.2174 21.7788 15.5055 21.7453L15.5771 21.7362L15.6229 21.6356C15.6473 21.5106 15.6564 21.3886 15.6564 21.2545C15.6564 21.102 15.6457 20.9359 15.632 20.7301L15.6122 20.4298C15.5207 19.038 15.4293 17.0289 15.4293 15.6936V15.5869C15.6671 15.7347 16.7006 16.3856 16.7006 16.3856C18.4612 17.5274 21.1182 19.253 22.7264 19.7088C22.8103 19.7347 22.8971 19.7149 22.9596 19.6554C22.9612 19.6524 23.2066 19.4969 23.2066 19.4969L23.2523 19.4786C23.3438 19.4344 23.4063 19.2789 23.417 19.1112C24.7706 19.0426 26.6593 18.5213 27.6699 17.2515C28.0617 16.7591 28.237 16.1555 28.237 15.6402C28.237 15.2164 28.1196 14.8521 27.9062 14.6509"
      fill="#F8B500"
    />
    <path
      d="M16.2111 25.9897V26.7275H17.9398V28.6451H17.3498V27.2381H13.8789V26.7275H15.6212V25.9897H13.5176V25.4805H17.3209V24.4607H13.9429V23.9531H17.9138V25.476H18.3361V25.9897H16.2111Z"
      fill="#7C7266"
    />
    <path
      d="M8.08203 23.9625H10.3899C11.4875 23.9625 12.0606 24.3268 12.0606 25.124C12.0606 25.6911 11.6658 26.0813 11.1384 26.1865V26.2063C11.8945 26.2963 12.2512 26.7917 12.2512 27.3496C12.2512 28.0508 11.7375 28.656 10.4631 28.656H8.08203V23.9609V23.9625ZM8.82897 25.9411H10.3518C10.9174 25.9411 11.335 25.7262 11.335 25.2262C11.335 24.7887 11.1292 24.4975 10.2649 24.4975H8.82897V25.9411ZM8.82897 28.1255H10.3046C11.2207 28.1255 11.4646 27.7688 11.4646 27.313C11.4646 26.7734 11.0911 26.4746 10.2664 26.4746H8.83049V28.1255H8.82897Z"
      fill="#7C7266"
    />
    <path
      d="M3 23.9609H3.74999V26.063L6.27281 23.9609H7.33529L4.66766 26.0829L7.55633 28.6575H6.49537L3.74999 26.1408V28.6575H3V23.9609Z"
      fill="#7C7266"
    />
  </svg>
);

const IconFinance = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
  >
    <rect width="36" height="36" fill="white" />
    <path
      d="M23.4624 9.75H12.5451C7.18453 13.3711 3.5625 17.8754 3.5625 23.0774C3.5625 29.7986 9.1106 33.3755 17.9995 33.3755C26.8884 33.3755 32.4365 29.7986 32.4365 23.0774C32.4365 17.8754 28.8145 13.3711 23.4539 9.75883L23.4624 9.75Z"
      fill="#FF8442"
    />
    <path
      d="M22.7964 9.13763H13.2119L11.676 4.80168C11.3907 3.70463 12.146 2.625 13.1867 2.625H22.8132C23.8539 2.625 24.6093 3.71334 24.3239 4.80168L22.788 9.13763H22.7964Z"
      fill="#FF8442"
    />
    <path
      d="M23.0577 6.84375H12.9371C12.0895 6.84375 11.4023 7.55551 11.4023 8.4335V8.44234C11.4023 9.32033 12.0895 10.0321 12.9371 10.0321H23.0577C23.9053 10.0321 24.5924 9.32033 24.5924 8.44234V8.4335C24.5924 7.55551 23.9053 6.84375 23.0577 6.84375Z"
      fill="#943F12"
    />
    <path
      d="M24.0125 19.6905H23.1271L23.7994 17.7015C23.8814 17.468 23.865 17.2183 23.7502 16.9929C23.6354 16.7674 23.4469 16.6064 23.2173 16.5258C22.9796 16.4372 22.7172 16.4534 22.4959 16.558C22.2663 16.6708 22.0942 16.864 22.0122 17.0976L20.5037 21.4298L18.9296 17.0895C18.7985 16.7432 18.446 16.5178 18.036 16.5178C17.6261 16.5178 17.2736 16.7432 17.1342 17.0976L15.5684 21.462L14.0025 17.0895C13.9205 16.856 13.7402 16.6708 13.5188 16.558C13.2893 16.4453 13.0351 16.4292 12.7974 16.5178C12.2973 16.6949 12.0432 17.2183 12.2153 17.7095L12.9122 19.6824H11.9858C11.4775 19.6824 11.043 20.1092 11.043 20.6084C11.043 21.1077 11.4775 21.5345 11.9858 21.5345H13.5844L14.6748 24.6025C14.7978 24.9487 15.1503 25.1742 15.5684 25.1742C15.9865 25.1742 16.3308 24.9487 16.4702 24.5944L18.0278 20.2219L19.6183 24.6025C19.7413 24.9487 20.0938 25.1742 20.5037 25.1742C20.9136 25.1742 21.2743 24.9407 21.4055 24.5783L22.4549 21.5425H24.0043C24.5126 21.5425 24.9471 21.1158 24.9471 20.6165C24.9471 20.1172 24.5126 19.6905 24.0043 19.6905H24.0125Z"
      fill="white"
    />
  </svg>
);

const IconBuilding = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
  >
    <rect width="36" height="36" fill="white" />
    <path
      d="M12.75 5.85714C12.75 4.27919 14.0292 3 15.6071 3H26.0921C27.8362 3 29.25 4.41384 29.25 6.15789V33H12.75V5.85714Z"
      fill="#99A8B0"
    />
    <path
      d="M6.75 11.8571C6.75 10.2792 8.02919 9 9.60714 9H20.0921C21.8362 9 23.25 10.4138 23.25 12.1579V33H6.75V11.8571Z"
      fill="#C7D0D6"
    />
    <rect x="11.5508" y="12.8984" width="2.4" height="2.4" fill="#718189" />
    <rect x="16.0527" y="12.8984" width="2.4" height="2.4" fill="#718189" />
    <rect x="11.5508" y="17.4062" width="2.4" height="2.4" fill="#718189" />
    <rect x="16.0527" y="17.4062" width="2.4" height="2.4" fill="#718189" />
    <rect x="11.5508" y="21.9062" width="2.4" height="2.4" fill="#718189" />
    <rect x="16.0527" y="21.9062" width="2.4" height="2.4" fill="#718189" />
    <path
      d="M12.9004 29.3969C12.9004 28.2371 13.8406 27.2969 15.0004 27.2969C16.1602 27.2969 17.1004 28.2371 17.1004 29.3969V32.9969H12.9004V29.3969Z"
      fill="#718189"
    />
  </svg>
);

const IconPeople = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
  >
    <rect width="36" height="36" fill="white" />
    <path
      d="M12.7133 19.6516C18.4733 19.6516 23.2583 24.2266 23.9633 30.1516H4.04327C2.63327 30.1516 1.64327 28.7566 2.10827 27.4366C3.72827 22.8766 7.86827 19.6516 12.7133 19.6516ZM25.6133 21.7516C29.2283 21.7516 32.3633 24.0166 33.8183 27.2716C34.4333 28.6216 33.4433 30.1516 31.9583 30.1516H26.3933L26.3633 29.8666C26.0033 26.9116 24.8033 24.2566 23.0333 22.1566C23.8583 21.9016 24.7283 21.7516 25.6283 21.7516H25.6133ZM25.7633 9.45156C28.4933 9.45156 30.7133 11.6716 30.7133 14.4016C30.7133 17.1316 28.4933 19.3516 25.7633 19.3516C23.0333 19.3516 20.8133 17.1316 20.8133 14.4016C20.8133 11.6716 23.0333 9.45156 25.7633 9.45156ZM12.7133 5.85156C15.8633 5.85156 18.4133 8.40156 18.4133 11.5516C18.4133 14.7016 15.8633 17.2516 12.7133 17.2516C9.56327 17.2516 7.01327 14.7016 7.01327 11.5516C7.01327 8.40156 9.56327 5.85156 12.7133 5.85156Z"
      fill="#69A7FF"
    />
  </svg>
);

const IconStar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
  >
    <rect width="36" height="36" fill="white" />
    <path
      d="M16.0149 3.94718C16.8768 2.08989 19.5114 2.07734 20.3909 3.92634L23.9342 11.3751L31.6989 12.3797C33.6889 12.6372 34.5175 15.0679 33.0994 16.4883L27.3763 22.2207L28.8417 30.9999C29.1289 32.7205 27.313 34.0191 25.7788 33.1904L18.1807 29.0857L10.5827 33.1904C9.04849 34.0191 7.23261 32.7205 7.5198 30.9999L8.98518 22.2207L2.80496 16.0304C1.57478 14.7983 2.29521 12.6896 4.02184 12.4686L12.5678 11.3751L16.0149 3.94718Z"
      fill="#FF7225"
    />
  </svg>
);

function FillBox({ children }: { children: React.ReactNode }) {
  return (
    <Box bg={baseColors.fill_normal} borderRadius="12px" px="20px" py="16px">
      {children}
    </Box>
  );
}

function BulletList({ items }: { items: string[] }) {
  return (
    <BaseStack spacing={8}>
      {items.map((item, i) => (
        <BaseStack key={i} direction="horizontal" spacing={8}>
          <Box
            flexShrink={0}
            className="body_2_normal_r"
            color={baseColors.label_alternative_1}
          >
            •
          </Box>
          <Box
            className="body_2_normal_r"
            color={baseColors.label_alternative_1}
          >
            {item}
          </Box>
        </BaseStack>
      ))}
    </BaseStack>
  );
}

function TrustItem({
  icon,
  title,
  body,
}: {
  icon: React.ReactNode;
  title: string;
  body: React.ReactNode;
}) {
  return (
    <BaseStack spacing={16} width="100%">
      <Box
        width="48px"
        height="48px"
        bg={colors.white}
        borderRadius="6px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
      >
        {icon}
      </Box>
      <Box>
        <Box
          className="headline_3_sb"
          css={responsive(PC_CRITERION_TITLE)}
          color={baseColors.label_normal}
          mb="4px"
        >
          {title}
        </Box>
        <Box
          className="body_1_reading_r"
          css={responsive(PC_BODY)}
          color={baseColors.label_alternative_1}
        >
          {body}
        </Box>
      </Box>
    </BaseStack>
  );
}

export default function FeedSangjoJoinContainer() {
  const router = useRouter();

  const goConsult = () => {
    customEvent({
      newGtm: { path: "sangjo_join", trigger_and_target: "btn_consult" },
    });
    call("1666-9784");
  };

  const go100won = () => {
    customEvent({
      newGtm: { path: "sangjo_join", trigger_and_target: "btn_100won" },
    });
    router.push("/?utm_campaign=sangjo_join_100won");
  };

  const goPrepare3 = () => {
    customEvent({
      newGtm: { path: "sangjo_join", trigger_and_target: "article_prep3" },
    });
    router.push("/content/feeds/prepare/3/");
  };

  return (
    <BaseStack width="100%" alignItems="center">
      {/* Hero — 모바일: 이미지만, PC: 이미지 + 그라디언트 + 타이틀 오버레이 */}
      <Box width="100%" position="relative">
        {/* 모바일: 이미지만 (타이틀 없음) */}
        <Box
          css={responsive({ display: { base: "block", lg: "none" } })}
          width="100%"
          overflow="hidden"
        >
          <Image
            src={getCdnImageSrc(
              "direct/content/feed/sangjo-join-mobile-header.png"
            )}
            alt=""
            width="100%"
          />
        </Box>

        {/* PC: 다크 배경 + 이미지 + 그라디언트 + 타이틀 오버레이 */}
        <Box
          css={responsive({ display: { base: "none", lg: "block" } })}
          position="relative"
          height="400px"
          bg="#868f94"
          overflow="hidden"
        >
          <Box position="absolute" inset="0" overflow="hidden">
            <Image
              src={getCdnImageSrc("direct/content/feed/sangjo-join-header.png")}
              alt=""
              width="100%"
              height="100%"
              css={{ objectFit: "cover" }}
            />
          </Box>
          {/* 그라디언트 오버레이 */}
          <Box
            position="absolute"
            inset="0"
            css={{
              backgroundImage:
                "linear-gradient(0deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.25) 40%, rgba(0,0,0,0.2) 50%, rgba(0,0,0,0) 100%)",
            }}
          />
          <Box position="absolute" bottom="40px" left="calc(50% - 340px)">
            <Box
              css={{
                fontSize: "56px",
                fontWeight: 500,
                lineHeight: "76px",
                letterSpacing: "-1px",
              }}
              color={colors.white}
              whiteSpace="pre-line"
            >
              {"상조 서비스,\n한 번에 정리해드립니다."}
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Content */}
      <Stack
        maxWidth="720px"
        width="100%"
        css={responsive({
          padding: { base: "32px 20px 80px", lg: "60px 0 100px" },
        })}
      >
        <BaseStack spacing={56}>
          {/* 모바일 전용 타이틀 + 부제목 */}
          <Box css={responsive({ display: { base: "block", lg: "none" } })}>
            <Box
              className="title_2_m"
              color={baseColors.label_normal}
              whiteSpace="pre-line"
              mb="8px"
            >
              {"상조 서비스,\n한 번에 정리해드립니다."}
            </Box>
            <Box
              className="body_1_reading_r"
              color={baseColors.label_alternative_1}
            >
              장례를 처음 준비하시는 분들을 위해,
              <br />
              상조 서비스가 무엇인지부터 어떻게 선택해야 하는지까지 모두 정리해
              드립니다.
            </Box>
          </Box>

          {/* PC 전용 부제목 (히어로 아래) */}
          <Box
            css={responsive({ display: { base: "none", lg: "block" } })}
            className="body_1_reading_r"
            color={baseColors.label_alternative_1}
          >
            장례를 처음 준비하시는 분들을 위해,
            <br />
            상조 서비스가 무엇인지부터 어떻게 선택해야 하는지까지 모두 정리해
            드립니다.
          </Box>

          {DIVIDER}

          {/* 섹션 1: 상조 서비스가 정확히 뭔가요? */}
          <BaseStack spacing={20}>
            <BaseStack spacing={8}>
              <Box
                className="headline_1_sb"
                css={responsive(PC_SECTION_TITLE)}
                color={baseColors.label_normal}
              >
                상조 서비스가 정확히 뭔가요?
              </Box>
              <Box
                className="body_1_reading_r"
                css={responsive(PC_BODY)}
                color={baseColors.label_alternative_1}
              >
                상조는 장례식이 발생했을 때 필요한 인력·차량·용품을 일괄로
                제공하는 서비스입니다.
                <br />
                장례식장 비용(빈소, 음식)과 장지 비용(화장장, 봉안당)을 제외한,
                장례 진행 그 자체를 책임지는 영역이라고 보시면 됩니다.
              </Box>
            </BaseStack>
            <FillBox>
              <BaseStack spacing={12}>
                <Box className="label_1_sb" color={baseColors.label_normal}>
                  [상조가 담당하는 범위]
                </Box>
                <BulletList
                  items={[
                    "장례지도사 3일간 동행 (장례의 품질을 좌우하는 핵심)",
                    "염습·입관 등 의전 진행",
                    "수의, 관, 유골함 등 장례 용품",
                    "운구 차량, 도우미 배차",
                    "화장장 예약, 앰뷸런스 등 행정 대행",
                  ]}
                />
              </BaseStack>
            </FillBox>
            <Box
              className="body_1_reading_r"
              css={responsive(PC_BODY)}
              color={baseColors.label_alternative_1}
            >
              쉽게 말해{" "}
              <Box as="span" fontWeight={600}>
                &ldquo;장례를 진행해주는 사람과 물건(차량, 장례 용품)의
                패키지&rdquo;
              </Box>
              입니다.
            </Box>
          </BaseStack>

          {DIVIDER}

          {/* 섹션 2: 선불제와 후불제 */}
          <BaseStack spacing={20}>
            <BaseStack spacing={8}>
              <Box
                className="headline_1_sb"
                css={responsive(PC_SECTION_TITLE)}
                color={baseColors.label_normal}
              >
                상조의 두 가지 방식: 선불제와 후불제
              </Box>
              <Box
                className="body_1_reading_r"
                css={responsive(PC_BODY)}
                color={baseColors.label_alternative_1}
              >
                상조사를 비교할 때 가장 먼저 알아야 할 건 결제 방식의
                차이입니다.
              </Box>
            </BaseStack>

            <BaseStack spacing={8}>
              {/* 모바일 16px SemiBold, PC 18px/29px */}
              <Box
                className="body_1_normal_sb"
                css={responsive({
                  fontSize: { lg: "18px" },
                  lineHeight: { lg: "29px" },
                })}
                color={baseColors.label_alternative_1}
              >
                [선불제 상조]
              </Box>
              <Box
                className="body_1_reading_r"
                css={responsive(PC_BODY)}
                color={baseColors.label_alternative_1}
              >
                장례 발생 전에 비용을 미리 나눠서 내는 방식입니다.
                <br />월 3만~5만 원씩 약 120회를 납입해 총 400만~600만 원이
                됩니다. 가입 시점의 가격을 평생 보장받는 대신, 큰 목돈이 장기간
                묶이고 중도 해지 시 환급률이 낮다는 단점이 있습니다.
              </Box>
            </BaseStack>

            <BaseStack spacing={8}>
              <Box
                className="body_1_normal_sb"
                css={responsive({
                  fontSize: { lg: "18px" },
                  lineHeight: { lg: "29px" },
                })}
                color={baseColors.label_alternative_1}
              >
                [후불제 상조]
              </Box>
              <Box
                className="body_1_reading_r"
                css={responsive(PC_BODY)}
                color={baseColors.label_alternative_1}
              >
                장례가 발생한 시점에 비용을 한 번에 지불하는 방식입니다.
                <br />
                사전에 내야 하는 비용 부담은 없지만, 장례 시점의 시세대로
                지불하기 때문에 매년 3~5%씩 오르는 가격 부담을 안고 가야 합니다.
              </Box>
            </BaseStack>

            <FillBox>
              <Box
                className="body_1_reading_r"
                css={responsive(PC_BODY)}
                color={baseColors.label_alternative_1}
              >
                선불제는{" "}
                <Box as="span" fontWeight={600}>
                  &ldquo;미리 부담을 지는 대신 가격을 잠구는&rdquo;
                </Box>{" "}
                방식,
                <br />
                후불제는
                <Box as="span" fontWeight={600}>
                  &ldquo;부담은 없지만 가격이 오를 위험을 안고 가는&rdquo;
                </Box>
                방식입니다.
              </Box>
            </FillBox>
          </BaseStack>

          {DIVIDER}

          {/* 섹션 3: 상조 가입 전 확인할 4가지 */}
          <BaseStack spacing={20}>
            <BaseStack spacing={8}>
              <Box
                className="headline_1_sb"
                css={responsive(PC_SECTION_TITLE)}
                color={baseColors.label_normal}
              >
                상조 가입 전 확인할 4가지
              </Box>
              <Box
                className="body_1_reading_r"
                css={responsive(PC_BODY)}
                color={baseColors.label_alternative_1}
              >
                어떤 상조사를 고르든, 다음 항목들은 반드시 확인하시는 것이
                좋습니다.
              </Box>
            </BaseStack>

            <BaseStack spacing={24}>
              {[
                {
                  title: "1. 장례지도사가 3일간 동행하는가",
                  body: "장례 품질에 가장 큰 영향을 미치는 요소입니다. 일부 저가 상품은 첫날만 동행하거나 동행하지 않는 경우도 있습니다.",
                },
                {
                  title: "2. 추가 비용 발생 조건이 명확한가",
                  body: "유골함, 수의 업그레이드, 도우미 수고비 등 변동 비용이 어떻게 책정되는지 사전에 확인이 필요합니다.",
                },
                {
                  title: "3. 계약 비용의 보장 기간",
                  body: "가입 시점의 가격이 실제 장례 시점에도 유효한지, 평생인지 일정 기간인지 확인하세요.",
                },
                {
                  title: "4. 환불·해지 규정",
                  body: "선불제의 경우 중도 해지 시 환급률과 위약금 여부를 확인해야 합니다.",
                },
              ].map((item, i) => (
                <BaseStack key={i} spacing={8}>
                  <Box
                    className="headline_3_sb"
                    css={responsive(PC_CRITERION_TITLE)}
                    color={baseColors.label_normal}
                  >
                    {item.title}
                  </Box>
                  <Box
                    className="body_1_reading_r"
                    css={responsive(PC_BODY)}
                    color={baseColors.label_alternative_1}
                  >
                    {item.body}
                  </Box>
                </BaseStack>
              ))}
            </BaseStack>
          </BaseStack>

          {DIVIDER}

          {/* 섹션 4: 고이 100원 상조 + 비교표 */}
          <BaseStack spacing={20}>
            <BaseStack spacing={8}>
              <Box
                className="headline_1_sb"
                css={responsive(PC_SECTION_TITLE)}
                color={baseColors.label_normal}
              >
                고이 100원 상조
              </Box>
              <Box
                className="body_1_reading_r"
                css={responsive(PC_BODY)}
                color={baseColors.label_alternative_1}
              >
                선불제와 후불제의 단점을 보완한 새로운 형태의 상조입니다.
                <br />
                선불제 상조지만{" "}
                <Box as="span" fontWeight="600">
                  월 납입금이 100원
                </Box>
                이기 때문에, 가입 시점의 가격을 평생 보장받으면서도 목돈이
                묶이는 부담이 없습니다.
              </Box>
            </BaseStack>

            {/* 5행 비교표 */}
            <Box width="100%" overflowX="auto" border="1px solid #dddedf">
              <Box minWidth="280px">
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(4, 1fr)"
                  bg="#36383a"
                >
                  {["구분", "기존 선불제", "후불제", "100원 상조"].map(
                    (h, i) => (
                      <Box
                        key={i}
                        px="8px"
                        py="10px"
                        className="label_1_sb"
                        css={responsive(PC_TABLE_LABEL)}
                        color={colors.white}
                        textAlign="center"
                      >
                        {h}
                      </Box>
                    )
                  )}
                </Box>
                {[
                  {
                    label: "월 납입금",
                    col1: "3만~5만 원",
                    col2: "없음",
                    col3: "월 100원",
                  },
                  {
                    label: "가격\n평생 보장",
                    col1: "가능",
                    col2: "불가능",
                    col3: "가능",
                  },
                  {
                    label: "목돈\n묶임",
                    col1: "N백만원\n발생",
                    col2: "없음",
                    col3: "3만원\n발생",
                  },
                  {
                    label: "중도 해지\n부담",
                    col1: "위약금 발생/\n환급률 낮음",
                    col2: "-",
                    col3: "위약금 없음",
                  },
                  {
                    label: "추가 요금\n발생",
                    col1: "가능성\n존재",
                    col2: "가능성\n존재",
                    col3: "없음",
                  },
                ].map((row, i, arr) => (
                  <Box
                    key={i}
                    display="grid"
                    gridTemplateColumns="repeat(4, 1fr)"
                  >
                    <Box
                      px="8px"
                      py="10px"
                      className="label_1_sb"
                      css={responsive({
                        ...PC_TABLE_CELL,
                        whiteSpace: { base: "pre-line", lg: "normal" },
                        borderBottom:
                          i < arr.length - 1 ? "1px solid #dddedf" : "none",
                      })}
                      color={baseColors.label_alternative_1}
                      textAlign="center"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      {row.label}
                    </Box>
                    <Box
                      px="8px"
                      py="10px"
                      className="label_1_r"
                      css={responsive({
                        ...PC_TABLE_CELL,
                        whiteSpace: { base: "pre-line", lg: "normal" },
                        borderBottom:
                          i < arr.length - 1 ? "1px solid #dddedf" : "none",
                      })}
                      color={baseColors.label_alternative_1}
                      textAlign="center"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      {row.col1}
                    </Box>
                    <Box
                      px="8px"
                      py="10px"
                      className="label_1_r"
                      css={responsive({
                        ...PC_TABLE_CELL,
                        borderBottom:
                          i < arr.length - 1 ? "1px solid #dddedf" : "none",
                      })}
                      color={baseColors.label_alternative_1}
                      textAlign="center"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      {row.col2}
                    </Box>
                    {/* 4열: borderBottom 없음 → 노란 배경 연속성 유지 */}
                    <Box
                      px="8px"
                      py="10px"
                      className="label_1_sb"
                      css={responsive({
                        ...PC_TABLE_CELL,
                        borderBottom:
                          i < arr.length - 1 ? "1px solid #dddedf" : "none",
                      })}
                      color={colors.orange650}
                      textAlign="center"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      bg="rgba(255, 241, 215, 0.7)"
                    >
                      {row.col3}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>

            <Box
              className="body_1_reading_r"
              css={responsive(PC_BODY)}
              color={baseColors.label_alternative_1}
            >
              기존 선불제 상조의{" "}
              <Box as="span" fontWeight="600">
                &ldquo;목돈이 10년간 묶이는 문제&rdquo;
              </Box>
              와 후불제의{" "}
              <Box as="span" fontWeight="600">
                &ldquo;매년 오르는 가격 부담&rdquo;
              </Box>
              을 모두 해결한 상품입니다.
            </Box>
          </BaseStack>

          {DIVIDER}

          {/* 믿고 맡길 수 있는 이유 */}
          <BaseStack spacing={24}>
            <BaseStack spacing={8}>
              <Box
                className="headline_1_sb"
                css={responsive(PC_SECTION_TITLE)}
                color={baseColors.label_normal}
              >
                믿고 맡길 수 있는 이유
              </Box>
              <Box
                className="body_1_reading_r"
                css={responsive(PC_BODY)}
                color={baseColors.label_alternative_1}
              >
                상조는 길게는 수십 년에 걸쳐 이어지는 서비스로 가입 전에 충분한
                고민이 필요합니다.
                <br />
                고이 100원 상조를 신뢰할 수 있는지 판단하실 수 있도록 고이가
                받은 검증과 운영 현황을 정리해드립니다.
              </Box>
            </BaseStack>

            {/* [정부·공공기관의 검증] */}
            <BaseStack spacing={12}>
              <Box
                className="headline_3_sb"
                css={responsive({
                  fontSize: { lg: "21px" },
                  lineHeight: { lg: "28px" },
                })}
                color={baseColors.label_normal}
              >
                [정부·공공기관의 검증]
              </Box>
              <FillBox>
                <BaseStack spacing={16}>
                  <TrustItem
                    icon={
                      <Image
                        src={getCdnImageSrc("direct/content/feed/ccm.png")}
                        alt="CCM"
                        width="36px"
                        height="36px"
                      />
                    }
                    title="소비자중심경영(CCM) 인증"
                    body={
                      <>
                        공정거래위원회와 한국소비자원이 운영하는 인증으로,
                        운영이 부실하면 받을 수 없습니다.
                        <br />
                        CCM을 받은 또 다른 기업엔 삼성전자·LG전자 등이 있습니다.
                      </>
                    }
                  />
                  {TRUST_DIVIDER}
                  <TrustItem
                    icon={<IconKB />}
                    title="제1금융권 선수금 예치"
                    body="납입하신 선수금은 KB국민은행에 예치되며, 상조사가 임의로 사용할 수 없는 구조로 안전하게 보관됩니다."
                  />
                </BaseStack>
              </FillBox>
            </BaseStack>

            {/* [재무 안정성] */}
            <BaseStack spacing={12}>
              <Box
                className="headline_3_sb"
                css={responsive({
                  fontSize: { lg: "21px" },
                  lineHeight: { lg: "28px" },
                })}
                color={baseColors.label_normal}
              >
                [재무 안정성]
              </Box>
              <FillBox>
                <BaseStack spacing={16}>
                  <TrustItem
                    icon={<IconFinance />}
                    title="지급여력비율 2,003%"
                    body="약속된 장례 서비스를 실제로 제공할 수 있는 재정적 능력을 나타내는 지표로, 업계 평균 대비 약 10배 수준입니다."
                  />
                  {TRUST_DIVIDER}
                  <TrustItem
                    icon={<IconBuilding />}
                    title="누적 투자 유치 119억 원"
                    body="업계 최초로 벤처투자를 유치한 상조사입니다."
                  />
                </BaseStack>
              </FillBox>
            </BaseStack>

            {/* [시장의 선택] */}
            <BaseStack spacing={12}>
              <Box
                className="headline_3_sb"
                css={responsive({
                  fontSize: { lg: "21px" },
                  lineHeight: { lg: "28px" },
                })}
                color={baseColors.label_normal}
              >
                [시장의 선택]
              </Box>
              <FillBox>
                <BaseStack spacing={16}>
                  <TrustItem
                    icon={<IconPeople />}
                    title="전국 18만 가족의 선택"
                    body="누적 18만 가족이 고이의 장례 서비스를 이용하셨습니다."
                  />
                  {TRUST_DIVIDER}
                  <TrustItem
                    icon={
                      <Image
                        src={getCdnImageSrc("direct/content/feed/kbba.png")}
                        alt="KBBA"
                        width="36px"
                        height="36px"
                      />
                    }
                    title="5년 연속 대한민국 최고브랜드 대상"
                    body="장례 서비스 부문에서 5년 연속 수상했습니다."
                  />
                  {TRUST_DIVIDER}
                  <TrustItem
                    icon={<IconStar />}
                    title="평균 만족도 4.9"
                    body="실제 장례를 진행한 유가족이 직접 매긴 점수와 후기를 확인해 보세요."
                  />
                </BaseStack>
              </FillBox>
            </BaseStack>
          </BaseStack>

          {/* FAQ */}
          <BaseStack spacing={16}>
            <Box
              className="headline_1_sb"
              css={responsive(PC_SECTION_TITLE)}
              color={baseColors.label_normal}
            >
              자주 묻는 질문
            </Box>
            <Accordion allowToggle>
              <Box bg={baseColors.fill_normal} overflow="hidden">
                {[
                  {
                    q: "100원 상조는 선불제인가요, 후불제인가요?",
                    a: "선불제 상조입니다. 다만 월 납입금이 100원이기 때문에 후불제처럼 가입 부담이 없으면서도, 선불제의 가격 평생 보장 혜택을 그대로 누리실 수 있습니다.",
                  },
                  {
                    q: "월 100원이 정말 전부인가요? 숨겨진 비용은 없나요?",
                    a: "네, 가입 단계에서는 월 100원이 유일한 비용입니다. 실제 장례가 발생했을 때 사전 안내된 가격대로만 결제되며, 그 외 추가 요구는 전액 환불 보장됩니다.",
                  },
                  {
                    q: "다른 상조 회사에 이미 가입했는데도 추가로 가입할 수 있나요?",
                    a: "네, 중복 가입 가능합니다. 기존 상조의 환급률이 낮다면 해지하지 않고 고이 프라임으로 대비해두는 분들도 많습니다.",
                  },
                  {
                    q: "가입 후 해지하고 싶으면 어떻게 되나요?",
                    a: "위약금 없이 언제든 해지 가능합니다.",
                  },
                  {
                    q: "장례가 발생했을 때 어떻게 연락하나요?",
                    a: "24시간 콜센터(1666-9784)로 연락주시면 즉시 출동합니다.",
                  },
                ].map((item, i, arr) => (
                  <AccordionItem
                    key={i}
                    border="none"
                    css={{
                      borderBottom:
                        i < arr.length - 1 ? "1px solid #dddedf" : "none",
                    }}
                  >
                    <AccordionButton
                      px="20px"
                      py="16px"
                      _hover={{ bg: "transparent" }}
                      gap="8px"
                    >
                      <Box
                        flex={1}
                        textAlign="left"
                        className="body_2_normal_m"
                        css={responsive(PC_FAQ)}
                        color={baseColors.label_normal}
                      >
                        {item.q}
                      </Box>
                      <AccordionIcon color={baseColors.label_alternative_1} />
                    </AccordionButton>
                    <AccordionPanel px="20px" pt="0" pb="16px">
                      <Box
                        className="body_1_reading_r"
                        color={baseColors.label_alternative_1}
                      >
                        {item.a}
                      </Box>
                    </AccordionPanel>
                  </AccordionItem>
                ))}
              </Box>
            </Accordion>
          </BaseStack>

          {/* CTA 버튼 — 모바일 상하, PC 좌우 */}
          <Box
            display="flex"
            css={responsive({
              flexDirection: { base: "column", lg: "row" },
              gap: "8px",
            })}
          >
            <Box
              flex={1}
              border={`1px solid ${baseColors.line_normal}`}
              borderRadius="6px"
              cursor="pointer"
              onClick={goConsult}
              px="12px"
              py="10px"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Box
                className="body_2_normal_m"
                color={baseColors.label_alternative_1}
                textAlign="center"
              >
                전문가와 상담 받아보기
              </Box>
            </Box>
            <Box
              flex={1}
              bg={baseColors.primary_orange}
              borderRadius="6px"
              cursor="pointer"
              onClick={go100won}
              px="12px"
              py="10px"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Box
                className="body_2_normal_m"
                color={colors.white}
                textAlign="center"
              >
                100원 상조 더 알아보기
              </Box>
            </Box>
          </Box>

          {/* 다른 컨텐츠 보기 → prepare/3 */}
          <Box
            display="flex"
            flexDirection="row"
            bg={baseColors.fill_normal}
            borderRadius="6px"
            overflow="hidden"
            alignItems="center"
            css={responsive({
              gap: { base: "16px", lg: "20px" },
              paddingRight: "20px",
              paddingLeft: { base: "20px", lg: "0" },
            })}
            cursor="pointer"
            onClick={goPrepare3}
          >
            {/* 썸네일: PC만 표시 */}
            <Box
              css={responsive({ display: { base: "none", lg: "block" } })}
              width="116px"
              height="88px"
              flexShrink={0}
              bg="#e8e9ea"
              overflow="hidden"
            >
              <Image
                src={getCdnImageSrc(
                  "direct/content/feed/good-funeral-thumbnail.png"
                )}
                alt=""
                width="100%"
                height="100%"
                css={{ objectFit: "cover", display: "block" }}
              />
            </Box>
            <Box flex={1} py="12px">
              <Box
                className="body_2_reading_r"
                css={responsive({
                  fontSize: { lg: "16px" },
                  lineHeight: { lg: "24px" },
                })}
                color={baseColors.label_alternative_1}
              >
                다른 컨텐츠 보기
              </Box>
              <Box
                className="body_1_normal_sb"
                css={responsive({
                  fontSize: { lg: "18px" },
                  lineHeight: { lg: "26px" },
                  letterSpacing: { lg: "-0.2px" },
                })}
                color={baseColors.label_normal}
              >
                좋은 상조 회사, 이렇게 고르세요
              </Box>
            </Box>
            <ColorIcon
              name="arrow_right_small"
              size={16}
              color={baseColors.label_alternative_1}
            />
          </Box>
        </BaseStack>
      </Stack>

      <Box width="100%" height="1px" bg={baseColors.line_normal} />
      <RenewalFooter />
    </BaseStack>
  );
}
